import React, { useCallback, useEffect, useState } from 'react'
import ZipExceptions from '../ZipExceptions'
import CityExceptions from '../CityExceptions'
import StateExceptions from '../StateExceptions'
import { ChoiceList } from '@shopify/polaris'
import "./style.css";

const ShippingExceptions = props => {
    const [selected, setSelected] = useState([])

    const handleChange = useCallback(value => {
        if (!props.disabled) {
            props.setExceptions(value)
            setSelected(value)
        }
    }, []);
    useEffect(() => {
        let exp = []
        if (selected.length === 0) {
            if (props.rate.exp_zip_codes) {
                exp.push("zip")
            }
            if (props.rate.exp_cities) {
                exp.push("city")
            }
            if (props.rate.exp_states) {
                exp.push("state")
            }
            setSelected(exp)
            props.setExceptions(exp)
        }
    }, [props.rate])

    return (
        <div>
            <ChoiceList
                allowMultiple
                disabled={props.disabled}
                choices={[
                    {
                        label: "Exclude zip codes from shipping area",
                        value: 'zip',
                        helpText: "Exclude specific zip codes from the designated shipping area for this method.",
                        renderChildren: isSelected => {
                            return isSelected ? <div className='rule zip'>
                                <ZipExceptions exp_zip_codes={props.rate.exp_zip_codes} handleChange={props.handleChange} isSelected={isSelected} />
                            </div> : null
                        }
                    },
                    {
                        label: "Exclude cities from shipping area",
                        value: 'city',
                        helpText: "Exclude specific cities from the designated shipping area for this method.",
                        renderChildren: isSelected => {
                            return isSelected ? <div className='rule city'>
                                <CityExceptions exp_cities={props.rate.exp_cities} handleChange={props.handleChange} disabled={props.disabled} isSelected={isSelected} />
                            </div> : null
                        }
                    },
                    {
                        label: "Exclude states from shipping area",
                        value: 'state',
                        helpText: "Exclude specific states/provinces from the designated shipping area for this method.",
                        renderChildren: isSelected => {
                            return isSelected ? <div className='rule state'>
                                <StateExceptions exp_states={props.rate.exp_states} handleChange={props.handleChange} disabled={props.disabled} isSelected={isSelected} />
                            </div> : null
                        },
                    }
                ]}
                selected={selected}
                onChange={handleChange}
            />
        </div>
    )
}

export default ShippingExceptions
